// extracted by mini-css-extract-plugin
module.exports = {"root":"Cta--root--2BQ7W","wrapper":"Cta--wrapper--20OMv","content":"Cta--content--fMXjQ","contact":"Cta--contact--2PnnY","image":"Cta--image--3UXYm"};